<template>
  <article class="coupon-info coupon-info-normal">
    <section class="coupon-sec1" :class="{'fn-hide': noCoupon}">
      <img :src="data.coupon.store.logo" alt="" class="logo-img">
      <!-- 卡券已使用 底部按钮隐藏-->
      <em class="icon-coupon-used" :class="{'fn-hide': !isConsumed}">
        <span class="time">{{data.coupon.write_off_at}}</span>
      </em>
      <em class="icon-coupon-expired" :class="{'fn-hide': !isConExpired}">
        <span class="time">{{data.coupon.write_off_at}}</span>
      </em>
      <div class="coupon-con1">
        <h2>
          <em>{{data.coupon.title}}</em>
        </h2>
        <p class="p2">价值<span class="fc-fb3f3f">{{data.coupon.face_value ? `${faceValue}元` : ' --'}}</span></p>
        <p class="p3">有效期：{{data.coupon.effective_at}} － {{data.coupon.expires_at}}</p>
        <div class="attention-info">
          <p class="p3">{{data.coupon.plate_number}}</p>
          <p class="p3">{{data.coupon.vin}}</p>
        </div>
      </div>
      <div class="coupon-con2">
        <mark class="coupon-con2__point">
          <div class="select-list-img">
            <ul>
              <li>
                <a>
                  <div class="select-img"><img :src="data.coupon.store.image_url" alt="" class="imgauto"></div>
                  <div class="select-detail">
                    <div>
                      <p class="p1">{{data.coupon.store.name}}</p>
                      <p>{{data.coupon.store.address}}</p>
                    </div>
                  </div>
                </a>
              </li>
            </ul>
          </div>
        </mark>
        <mark class="coupon-con2__point">
          <div class="display-flex">
            <label>成本部门</label>
            <span class="flex1">{{ data.coupon.cost_department_name }}</span>
          </div>
        </mark>
        <div class="coupon-con2__pkg-source display-flex" v-if="data.coupon.coupon_source">
          <label>所属券包</label>
          <span class="flex1">{{ data.coupon.coupon_source }}</span>
        </div>
        <div class="coupon-con2__pkg-source display-flex">
          <label>卡券成本</label>
          <span class="flex1">{{ couponCost }}元</span>
        </div>
        <div class="coupon-con2__info">
          <div class="coupon-con2__info--name">发放原因</div>
          <template v-if="data.coupon.reason || (data.coupon.images && data.coupon.images.length)">
            <div class="coupon-con2__info--value">{{ data.coupon.reason }}</div>
            <div class="coupon-con2__info--imgs" v-if="data.coupon.images && data.coupon.images.length">
              <img
                v-for="(imgSrc, index) in data.coupon.images"
                :key="`${imgSrc}-${index}`"
                :src="imgSrc"
                @click="handlePreview(data.coupon.images, index)"
              />
            </div>
          </template>
          <div class="coupon-con2__info--value" v-else>--</div>
        </div>
      </div>
    </section>
    <section class="btn-bottom" v-if="needWriteOff">
      <div class="btn-fix">
        <a class="btn" href="javascript:void(0);" @click="showCheckDialog = true">核销</a>
      </div>
    </section>
    <coupon-write-off
      :visible.sync="showCheckDialog"
      :loading="writeOffLoading"
      @on-confirm="onWriteOff"
      @on-cancel="cancelWriteOff"
    ></coupon-write-off>
    <div class="tip-result-box" :class="{'fn-hide': data.hideTipBox}">
      <div class="bg-filter"></div>
      <div class="tip-filter-center ">
        <div class="tip-result">
          <i class="result-ico icon-tipico-ok"></i>
          <p class="result-hd">核销成功</p>
        </div>
      </div>
    </div>
    <section class="data-messages-null" :class="{'fn-hide': !noCoupon}">
      <i class="icon-no-coupon"></i> 没有找到对应的券
    </section>
  </article>
</template>
<script>
import util from '../../common/util'
import CouponWriteOff from './features/BizCouponWriteOff.vue'
export default {
  components: {
    CouponWriteOff
  },
  data() {
    return {
      data: {
        hideTipBox: true,
        coupon: {
          store: {}
        }
      },
      noCoupon: false,
      showCheckDialog: true,
      orderId: '',
      consultantName: '', // 业务顾问姓名
      writeOffLoading: false
    }
  },
  computed: {
    isConsumed() {
      let isConsumed = false
      if (this.data.coupon) {
        isConsumed = this.data.coupon.status === 'consumed'
      }
      return isConsumed
    },
    isConExpired() {
      let isConExpired = false
      if (this.data.coupon) {
        isConExpired = this.data.coupon.status === 'canceled'
      }
      return isConExpired
    },
    needWriteOff() {
      let needWiteOff = false
      if (this.data.write_off_cashier && this.data.coupon) {
        needWiteOff = this.data.coupon.status === 'issued'
      }
      return needWiteOff
    },
    faceValue() {
      return (this.data.coupon.face_value / 100).toFixed(2)
    },
    couponCost() {
      const { cost_price } = this.data.coupon

      if (!cost_price) {
        return 0
      }

      return (cost_price / 100).toFixed(2)
    }
  },
  created() {
    const cou = this.$store.state.cou
    this.consultantName = cou.consultant.name
    this.orderId = cou.couponCode
    this.showCheckDialog = cou.showCheckDialog
    this.$store.dispatch('UPDATE_SHOW_DIALOG', false)
  },
  mounted() {
    this.code = this.$route.params.code
    this.$rest.cou.getCouponDetail(null, this.code).then(res => {
      if (res.code === 0) {
        if (res.data.coupon) {
          let data = res.data
          data.hideTipBox = true
          this.data = data
        } else {
          this.noCoupon = true
        }
      } else {
        this.showToast(res.message)
      }
    })
  },
  methods: {
    handlePreview(images, index) {
      this.$wechat.wx.previewImage({
        current: images[index],
        urls: images
      })
    },
    onWriteOff({ orderId, projects, remark }) {
      if (!util.regexpMap.regexp_order_id.test(orderId)) {
        this.showToast('业务单号只能包含数字和字母，且不超过50个字符！')
        return
      }
      this.orderId = orderId
      const params = {
        remark,
        consumed_order_id: orderId,
        projects
      }
      this.writeOffLoading = true
      this.$rest.cou.writeOffCoupon(params, this.code).then(res => {
        this.writeOffLoading = false
        if (res.code === 0) {
          this.data.hideTipBox = false
          this.showCheckDialog = false
          setTimeout(() => {
            this.data.hideTipBox = true
            this.$router.go(-1)
          }, 1000)
        } else {
          this.showToast(res.message)
        }
      }).catch(() => {
        this.writeOffLoading = false
      })
    },
    cancelWriteOff() {
      this.orderId = ''
      this.showCheckDialog = false
    },
    handleDelete() {
      this.consultantName = ''
    }
  }
}
</script>
<style lang="less">
@import "../../stylesheets/base/fn";
.coupon-info-normal {
  .logo-img {
    top: 10/@w2 !important;
  }
}
.consultant {
  display: flex;
  align-items: center;
  margin-top: 28/@w2;
  padding: 10/@w2 30/@w2 10/@w2 20/@w2;
  border-radius: 5px;
  border: solid 1px #d8dce6;
  .consultant__input {
    width: 80%;
    background-color: transparent;
    font-size: inherit;
    line-height: 2.26666667;
    &--placeholder {
      color: #999;
    }
  }
  .delete-icon {
    width: 40/@w2;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 25/@w2;
  }
  .with-arrow {
    display: inline-block;
    &::after {
      content: " ";
      display: inline-block;
      -webkit-transform: rotate(45deg);
      transform: rotate(45deg);
      height: .21333333rem;
      width: .21333333rem;
      border-width: 1px 1px 0 0;
      border-color: #a0a0a0;
      border-style: solid;
      position: relative;
      margin-left: .3em;
    }
  }
}
.order-id-input {
  margin-top: 28/@w2;
  border-radius: 5px;
  border: solid 1px #d8dce6;
  &.weui_cell {
    padding: 10/@w2 20/@w2;
  }
  &.weui_cell:before {
    width: 0;
  }
}
.coupon-con2 {
  &__pkg-source {
    display: flex;
    justify-content: space-between;
    padding: 0 31/@w2;
    height: 80/@w2;
    line-height: 80/@w2;
    border-top: 1px solid #F5F5F6;
    font-size: 26/@w2;
    label, span {
      display:flex;
    }
  }
  &__info {
    padding: 25/@w2 31/@w2 21/@w2;
    border-top: 1px solid #F5F5F6;
    font-size: 26/@w2;
    &--value {
      margin-top: 11/@w2;
      word-break: break-all;
      line-height: 1.5;
      color: #999;
    }
    &--imgs {
      display: flex;
      flex-wrap: wrap;
      margin-top: 17/@w2;
      img {
        width: 124/@w2;
        height: 124/@w2;
        margin: 0 12/@w2 12/@w2 0;
        border-radius: 9/@w2;
      }
    }
  }
  .select-detail {
    .p1 {
      margin-top: 0!important;
    }
  }
}
</style>
